$(function () {
  const fadeTexts = document.querySelectorAll(".fade-text");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );
  fadeTexts.forEach((el) => observer.observe(el));
});
